import { Box, Button, useMultiStyleConfig, useTab } from '@chakra-ui/react'
import React from 'react'

export const FancyTab = React.forwardRef<HTMLElement, any>((props, ref) => {
  const tabProps = useTab({ ...props, ref })
  const isSelected = !!tabProps['aria-selected']
  const styles = useMultiStyleConfig('Tabs', tabProps)

  return (
    <Button
      __css={styles.tab}
      sx={{
        '&[aria-selected=true]': {
          fontWeight: 'normal'
        }
      }}
      {...tabProps}
      _focus={{
        boxShadow: 'none'
      }}
      border="none"
      fontSize="14px"
      m="0px"
      p="0px"
    >
      <Box width="100%" p="8px" pt="4px">
        {tabProps.children}
      </Box>
      <Box px="8px">
        <Box
          width="100%"
          height="4px"
          borderRadius="2px"
          backgroundColor={isSelected ? 'primary' : 'transparent'}
        />
      </Box>
    </Button>
  )
})
